// @flow
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { CSRF_COOKIE_NAME, HOST } from '../foxford/constants'
import { RequestInterceptor } from './interceptors/request'
import { ResponseInterceptorSuccess } from './interceptors/response'
import { ResponseInterceptorFail } from './interceptors/responseFail'

const ApiService = axios.create({
  timeout: 10000,
  baseURL: HOST,
  withCredentials: true,
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: 'X-CSRF-Token',
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

ApiService.interceptors.request.use(RequestInterceptor)
ApiService.interceptors.response.use(ResponseInterceptorSuccess, ResponseInterceptorFail)

axiosRetry(ApiService, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
})

export { ApiService as Api }
